// extracted by mini-css-extract-plugin
export default {"root":"SignResult_root__QhNcN","tip":"SignResult_tip__3Fg3+","time":"SignResult_time__IpC91","button":"SignResult_button__teRvv"};